import { buildDomainSeoBundle } from "./agenticSeoUtils";

export const AGRICULTURE_DOMAIN_INTRO = {
  title: "Agriculture & Food Processing",
  content: "Agentic AI workflow automation for Agriculture & Food Processing — across Food Brands. Use cases span customer complaint traceability with governed workflow automation, human review, and audit evidence. Practical deployments for food brands and processors in India, UAE, KSA, UK, and USA.",
  seoDescription: "Agriculture food processing agentic AI — customer complaint traceability. ERP QMS CRM traceability system integration.",
};

const slug = (label) => label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

function withMeta(uc) { return { ...uc, groupId: slug(uc.subIndustry), seoTitle: uc.title, title: uc.shortTitle || uc.title }; }

const AGRICULTURE_SYSTEMS = "ERP, QMS, CRM, Traceability System, Email, Power BI";

const RAW = [
  {
    id: "customer-complaint-traceability",
    subIndustry: "Food Brands",
    department: "Customer Quality",
    businessProcess: "Customer complaint traceability",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Customer complaint traceability",
    title: "Customer Complaint Traceability Automation for Agriculture & Food Processing",
    seoKeywords: "agriculture & food processing, customer complaint traceability, AI automation, RPA, agentic AI",
    challenge: "Customer complaints are manually traced to batch, plant, raw material and dispatch records.",
    solution: "Implement Agentic AI + Data Automation to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    summary: "Food Brands teams can improve customer complaint traceability with agentic AI workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + Data Automation",
    buyerPersona: "QA Head, Customer Service Head",
    systems: AGRICULTURE_SYSTEMS,
    agentsRequired: "Data Collection Agent, Customer Insight Agent, Alert Agent",
    inputData: "System exports, transaction records, logs, historical data, master data and customer complaint traceability business rules",
    outputActions: "Dashboard, anomaly alerts, forecast or action list for customer complaint traceability",
    keyBenefits: "Stronger Controls, Faster Review, Clearer Audit Trail And Fewer Missed Exceptions",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
];
export const AGRICULTURE_USE_CASES = RAW.map(withMeta);
const GROUP_ORDER = ["Food Brands"];
export const AGRICULTURE_GROUPS = GROUP_ORDER.map((label) => ({ id: slug(label), label })).filter((g) => AGRICULTURE_USE_CASES.some((uc) => uc.groupId === g.id));
const seo = buildDomainSeoBundle({ domainSlug: 'agriculture-domain', domainIntro: AGRICULTURE_DOMAIN_INTRO, useCases: AGRICULTURE_USE_CASES });
export const AGRICULTURE_USE_CASES_SEO = seo.useCasesSeo;
export const AGRICULTURE_DOMAIN_FAQS = seo.domainFaqs;
export const AGRICULTURE_ITEM_LIST_JSONLD = seo.itemListJsonLd;
export const AGRICULTURE_FAQ_JSONLD = seo.faqJsonLd;
export const AGRICULTURE_BREADCRUMB_JSONLD = seo.breadcrumbJsonLd;
export const AGRICULTURE_WEBPAGE_JSONLD = seo.webPageJsonLd;

